<template>
  <div class="modal i8-modal" :class="{ 'is-active': isOpen }">
    <div class="modal-background"/>
    <div
      class="modal-card i8-modal__card"
      :class="{'i8-modal--wide': getOption('width') == 'wide',
                   'i8-modal--medium': getOption('width') == 'medium',
                   'i8-modal--auto': getOption('width') == 'auto'}"
    >
      <div class="modal-content i8-modal__content">
        <header v-if="title != ''" class="modal-card-head">
          <p class="modal-card-title">{{title}}</p>
          <!-- Remove as not DCE compliant -->
          <!-- <button
            v-if="showClose"
            class="delete"
            aria-label="close"
            data-ci="close-modal"
            @click="cancel"
          /> -->
        </header>

        <section class="modal-card-body" v-if="isSlotEmpty('i8-modal-body')">
          <slot name="i8-modal-body"/>
        </section>

        <footer class="modal-card-foot" v-if="isSlotEmpty('i8-modal-footer')">
          <slot name="i8-modal-footer"/>
        </footer>
      </div>
    </div>
    <!-- modal-card -->
  </div>
  <!-- modal -->
</template>

<script>
import { isUndefined } from 'lodash';
const name = 'i8-modal';

export default {
    name,
    componentName: name,

    props: {
        showClose: { default: true, type: Boolean },
        isOpen: { default: false, type: Boolean },
        title: { default: '', type: String },
        options: {
            default: () => {
                width: 'normal';
            },
            type: Object,
        },
    },

    data() {
        return {
            strings: {
                cancelBtn: 'Cancel',
            },
        };
    },

    created() {},

    computed: {},

    watch: {},

    methods: {
        // get an option value by key
        getOption(optionKey) {
            if (isUndefined(this.options) || isUndefined(this.options[optionKey])) {
                return false;
            }
            return this.options[optionKey];
        },

        // check if a named slot has been populated
        isSlotEmpty(slotName) {
            return !!this.$slots[slotName];
        },
        cancel() {
            this.$emit('cancel');
        },
    },
};
</script>



// WEBPACK FOOTER //
// shared/components/I8Modal.vue